import React from 'react';
import styled from 'styled-components';

import { CompleteStatusEnum } from '~/api/book/bookApiTypes';
import { Divider } from '~/atomic/atom/Divider';
import { BookStatus, SCStatus } from '~/atomic/molecula/BookStatus';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { CycleBookList } from '~/atomic/page/author/books/CycleBookList';
import { EmptyAuthorBooksPage } from '~/atomic/page/author/books/EmptyAuthorBooksPage';
import { SCContent } from '~/atomic/page/author/styled';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';
import { currentCycleSelector } from '~/feature/cycle/cycleSlice';
import { Linkify } from '~/feature/utils/Linkify';
import { lessThan } from '~/lib/mediaQuery';
import { useAppSelector } from '~/store';

export const Cycle = () => {
  const currentCycle = useAppSelector(currentCycleSelector);
  const { currentAuthor } = useAppSelector(authorSelector);

  if ((currentCycle?.books?.length ?? 0) < 1) return <EmptyAuthorBooksPage />;

  const books = currentCycle?.books.slice()
    .sort((prevBook, nextBook) => {
      return prevBook.cycle.numInCycle - nextBook.cycle.numInCycle;
    }) ?? [];
  const firstBook = books[0];

  return (
    <SCContent>
      <SCTitleRow>
        <SCTitle>
          Серия книг
          {' '}
          {currentCycle?.name ?? ''}
          {' '}
          /
          {' '}
          {currentAuthor?.name}
        </SCTitle>
        <BookStatus type={
          currentCycle?.complete
            ? CompleteStatusEnum.Complete
            : CompleteStatusEnum.Writing
        }
        />
      </SCTitleRow>
      <>
        {firstBook?.annotation && (
          <Linkify>
            <SCAuthorDescription>
              {firstBook.annotation}
            </SCAuthorDescription>
          </Linkify>
        )}
        <SCSubTitle>
          Читайте книги из серии
          {' '}
          {currentCycle?.name}
          {' '}
          онлайн:
        </SCSubTitle>
        <Divider />
        <CycleBookList books={books} />
      </>
    </SCContent>
  );
};

const SCTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  
  ${SCStatus} {
    margin-left: 16px;
  }
  
  ${lessThan('sm')} {
    flex-direction: column;
    align-items: flex-start;
    
    ${SCStatus} {
      margin-left: unset;
      margin-top: 8px;
    }
  }
`;

const SCAuthorDescription = styled.div`
  white-space: pre-line;
`;

const SCTitle = styled.h1`
  ${PageTitleStyle};
`;

const SCSubTitle = styled.h2`
  ${TextRegStyle};
`;
